import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Button, Paper, Grid, TextField } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import Typography from '@material-ui/core/Typography';
import ErrorMessage from './ErrorMessage';

// This is used when log in into company after user has logged in to his/her account.
// So in case the user doens't have any company without password. 

@inject('authStore', 'viewStore')
@observer
class LoginToCompany extends Component {
    constructor(props) {
        super(props);
        this.state = { password: "", passwordError: false }

        this.handleLogin = this.handleLogin.bind(this);
        this.handleClose = this.handleClose.bind(this);
    }

    handleLogin() {
        if (this.state.password === "") {
            this.setState({ passwordError: true });
        }
        else {
            this.setState({ password: "" });
            this.props.authStore.setTempCompanyPassword(this.state.password);
            this.props.authStore.loginCompany();
        }

    }
    handleClose() {
        this.props.authStore.logout();
    }
    render() {
        const { authStore } = this.props;

        return (
            <div>
                <Grid
                    alignItems="center"
                    container
                    justifyContent="center"
                    style={{ minHeight: '100vh' }}>
                    <Grid item md={6} lg={4} >
                        {
                            authStore.loginDialogLoading
                                ?
                                <Grid container justifyContent="center">
                                    <Grid item>
                                        <CircularProgress size={70} />
                                    </Grid>
                                </Grid>
                                :
                                <Paper style={{ padding: 20, margin: 30 }} align="center">
                                    <Typography component={'span'} >Yritys jolle yrität kirjautua vaatii salasanan</Typography>
                                    <br></br>
                                    <Typography component={'span'} variant="h5">{authStore.tempCompany.NAME}</Typography>
                                    <TextField
                                        id="password"
                                        margin="dense"
                                        label="Salasana"
                                        type="password"
                                        autoFocus
                                        autoComplete="current-password"
                                        fullWidth
                                        value={this.state.password}
                                        onChange={e => this.setState({ password: e.target.value })}
                                        error={this.state.passwordError}
                                    />
                                    <br></br>
                                    <ErrorMessage />
                                    <Button onClick={this.handleLogin} color="primary">
                                        Kirjaudu sisään
                                    </Button>
                                    <Button onClick={this.handleClose} >
                                        Peruuta
                                    </Button>
                                </Paper>
                        }
                    </Grid>
                </Grid>
            </div >
        )
    }
}
export default LoginToCompany